exports = module.exports = require("../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".situation[data-v-49573e69] {\n  text-decoration: underline;\n}", ""]);

// exports
